import { useNavigate } from 'react-router-dom';
import { Button } from '@peacecover/component';
import { ReactComponent as RainbowCheckCircleFill } from '../../icons/rainbow.check.circle.fill.svg';

const RefundSuccessPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-[17px]">
      <RainbowCheckCircleFill width={94} height={94} />
      <div className="flex flex-col items-center justify-center gap-[24px] w-full px-[24px]">
        <p className="text-[24px] font-bold text-text-main-lv2 leading-[29px]">
          환불 요청이 완료되었어요
        </p>
        <p className="text-[13px] font-medium leading-[16px] text-text-main-lv4 text-center">
          검토 후, 사용한 결제수단으로 환불처리되며
          <br />
          영업일 기준 1~2일 소요됩니다.
        </p>
      </div>
      <div className="fixed bottom-0 left-0 right-0 px-[24px] pb-[calc(env(safe-area-inset-bottom)+10px)]">
        <Button
          size="large"
          className="w-full text-[17px] font-semibold leading-[20px]"
          onClick={() => navigate('/bettie/purchase-history', { replace: true })}
        >
          확인
        </Button>
      </div>
    </div>
  );
};

export default RefundSuccessPage;
